import styled from "styled-components";

export const Container = styled.div`
    width: 90vw;
   margin: 50px auto;
    .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h1 {
      font-size: 2.1875rem;
      font-weight: 600;
      color: #3f3d56;
    }
  }

  .container{
    border: 1px solid #3f3d56;
    border-radius: 10px;
    margin-top: 20px;

  }

  .linha{
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #3f3d56;
      padding: 20px 50px;
    }

    .linha-total{
      display: flex;
      justify-content: space-between;
      padding: 20px 50px;
      font-weight: bold;
    }

  .box{
    display: flex;
    justify-content: space-between;
    margin-top: 120px;
    gap: 15px;
    position: relative;
    z-index: 2;
    border-radius: 10px;
    background-color: #ffffff;
    .dog{
      width: 45vw; 
      border: 1px solid #3f3d56;
      border-radius: 10px;
      position: relative;

      .img-dog{
        position: absolute;
        bottom: 7rem;
        left: 1vw;
      }
    }

    .cat{
      width: 45vw;
      border: 1px solid #3f3d56;
      border-radius: 10px;
      position: relative;

      .img-cat{
    position: absolute;
    bottom: 5.4rem;
    left: -6rem;

  }
    }
  }

  @media screen and (max-width: 808px) {
    .box{
    .dog{
      .img-dog{
        bottom: 8.4rem;
      }
    }
    .cat{
      .img-cat{
    bottom: 6.8rem;

  }
    }
  }
  }
  
  @media screen and (max-width: 808px) {
    .box{
      flex-direction: column;
      .dog{
        width: 90vw;
        margin-bottom: 6.25rem;
      .img-dog{
        bottom: 7rem;
      }
    }

    .cat{
      width: 90vw;
      .img-cat{
        bottom: 5.4rem;

  }
    }
  }
  }
  
  @media screen and (max-width: 397px) {
    .box{
    .dog{
      .img-dog{
        bottom: 8.4rem;
      }
    }
  }
}

@media screen and (max-width: 397px) {
    .box{

    .cat{
      .img-cat{
        
        bottom: 6.9rem;
  }
    }
  }
  }

  @media screen and (max-width: 393px) {
    .box{

    .cat{
      .img-cat{
        
        bottom: 5.4rem;
  }
    }
  }
  }

  @media screen and (max-width: 360px) {
    .box{

    .cat{
      .img-cat{
        
        bottom: 6.9rem;
  }
    }
  }
  }

 

`